import type { SearchScope } from '../api/searchTypes';
import { readParam, withParam } from './searchParams';

// Events and Markets share one set of parameters, exactly as before the trader
// scope existed. Traders keep their own set. Spec 6.2: the URL holds only the
// active set; the other one lives in component state for the session.
export type ScopeGroup = 'markets' | 'traders';
export type ScopeMemory = Partial<Record<ScopeGroup, string>>;

export interface ScopeSwitch {
    params: URLSearchParams;
    memory: ScopeMemory;
}

export function scopeGroup(scope: SearchScope): ScopeGroup {
    return scope === 'trader' ? 'traders' : 'markets';
}

export function switchScope(
    params: URLSearchParams,
    from: SearchScope,
    to: SearchScope,
    memory: ScopeMemory,
    allowedSorts: readonly string[]
): ScopeSwitch {
    let next: URLSearchParams;
    let nextMemory = memory;
    const crossing = scopeGroup(from) !== scopeGroup(to);

    if (!crossing) {
        next = params;
    } else {
        const saved = new URLSearchParams(params);
        saved.delete('q');
        nextMemory = { ...memory, [scopeGroup(from)]: saved.toString() };
        next = new URLSearchParams(memory[scopeGroup(to)] ?? '');
        const q = params.get('q');
        if (q) next.set('q', q);
        else next.delete('q');
    }

    next = withParam(next, 'scope', to);
    if (!allowedSorts.includes(readParam(next, 'sort'))) {
        next = withParam(next, 'sort', null);
    }
    if (crossing && !next.get('q') && next.get('sort') === 'relevance') {
        next = withParam(next, 'sort', null);
    }
    return { params: next, memory: nextMemory };
}
